export type HapticImpactStyle = "light" | "medium" | "heavy";
export type HapticNotificationKind = "success" | "warning" | "error";

/** Абстракция тактильной обратной связи. */
export interface HapticsAdapter {
  impact(style: HapticImpactStyle): void;
  selection(): void;
  notification(kind: HapticNotificationKind): void;
}

/** Web-реализация через navigator.vibrate (fallback no-op). */
export class WebHapticsAdapter implements HapticsAdapter {
  private vibrate(pattern: number | number[]): void {
    if (typeof navigator !== "undefined" && typeof navigator.vibrate === "function") {
      try {
        navigator.vibrate(pattern);
      } catch {
        // no-op — API недоступно
      }
    }
  }

  /** Тактильный удар с заданной силой. */
  impact(style: HapticImpactStyle): void {
    const ms = style === "light" ? 10 : style === "medium" ? 18 : 28;
    this.vibrate(ms);
  }

  /** Короткий отклик при выборе элемента. */
  selection(): void {
    this.vibrate(8);
  }

  /** Системное уведомление с паттерном вибрации. */
  notification(kind: HapticNotificationKind): void {
    const pattern =
      kind === "success" ? [10, 40, 10] : kind === "warning" ? [20, 60, 20] : [30, 80, 30, 80, 30];
    this.vibrate(pattern);
  }
}
